eshopApp.controller('FeaturedCategoriesController', ['$scope', '$http', function($scope, $http) {

	$scope.module_visible = false;
	$scope.spinner = true;

	$scope.categories;

	// Get categories
	$scope.fetch = function() {
		$http.get('/m/categories/featured/featuredcategories-homepage').success(function(response){
			if (response.data) {
				$scope.categories = response.data.categories;
				$scope.images = response.data.images;
			}
		}).finally(function(){
			$scope.spinner = false;
		});
	}
	// Init
	$scope.fetch();

}]);